





















import { computed, defineComponent } from "@vue/composition-api";
import { $t } from "@/lib/i18nHelpers";

export default defineComponent({
  name: "LandingCreatorsCommitment",
  setup() {
    const items = computed(() => [
      {
        key: "earnings",
        title: $t("Earnings"),
        text: $t("Take home up to 80% of what you generate. Transparent payouts — no hidden costs."),
        icon: "img/landingCreators/icons/earnings.svg",
      },
      {
        key: "visibility",
        title: $t("Worldwide Visibility"),
        text: $t("Get discovered worldwide in curated feeds, recommendations, and promotions."),
        icon: "img/landingCreators/icons/visibility.svg",
      },
      {
        key: "collaboration",
        title: $t("Earn More — Automatically"),
        text: $t("Earn ongoing commissions when creators or fans join through your personal referral link."),
        icon: "img/landingCreators/icons/collaboration.svg",
      },
      {
        key: "monetization",
        title: $t("Complete Monetization Toolkit"),
        text: $t("Subscriptions, DMs, tips, lives, posts, and video calls — everything in one place."),
        icon: "img/landingCreators/icons/monetization.svg",
      },
    ]);

    return {
      items,
    };
  },
});
